import React, { Component, PropTypes } from 'react';
import styled from 'styled-components';
import includes from 'lodash/includes';
import CircularProgress from 'material-ui/CircularProgress';
import Snackbar from 'material-ui/Snackbar';
import { CardHeader } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ArrowUpIcon from 'material-ui/svg-icons/navigation/arrow-upward';
import SearchIcon from 'material-ui/svg-icons/action/search';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import orderBy from 'lodash/orderBy';
import { database } from '../../utils/configureFirebase';
import csvConverter from '../../utils/SavedDrivesCSV';
import DriveCard from '../../components/DriveCard';
import { theme } from '../../utils/getTheme';

const ContentWrapper = styled.div`
  width: 80%;
  margin: 0 auto;
`;

const ContentContainer = styled.div`
  marginTop: 16px;
  & > * + * {
    margin-top: 16px;
  }
`;

const LoaderWrapper = styled.div`
  text-align: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const DataWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
`;

const SearchWrpper = styled.div`
  display: flex;
  justify-content: center;
  align-item: center;
  background-color: white;
  border-radius: 25px;
`;

const FloatingButtonContianer = styled.div`
  position: fixed;
  bottom: 12px;
  right: 12px;
`;


class SavedDrives extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      drives: undefined,
      candidates: undefined,
      searchText: '',
      filteredData: [],
      emptySearchOpen: false,
    };

    this.driveRef = undefined;
  }

  componentDidMount() {
    this.driveRef = database.ref('drives');
    this.driveRef.on('value', this.setDrivesData);

    this.candidateRef = database.ref('registrations');
    this.candidateRef.on('value', this.setCandidateData);
  }

  componentWillUnmount() {
    this.driveRef.off('value', this.setDrivesData);
  }

  setCandidateData = (snapshot) => {
    if (snapshot) {
      const candidates = snapshot.val();
      this.setState(() => ({
        candidates,
        isLoading: false,
      }));
    }
  }

  setDrivesData = (snapshot) => {
    if (snapshot) {
      const drives = snapshot.val();
      this.setState(() => ({
        drives,
      }));
    }
  }

  getDrivesArray = (drives, candidates) => {
    if (drives) {
      const drivesArr = Object.keys(drives).map((id) => {
        let count = 0;
        if (candidates && candidates[id] !== undefined) {
          count = Object.keys(candidates[id]).length;
        } else {
          count = 0;
        }
        return {
          ...drives[id],
          id,
          count,
        };
      });

      // console.log('drive data : ', orderBy(drivesArr, drive => drive.timestamp, 'desc'));
      return orderBy(drivesArr, drive => drive.timestamp, 'desc');
    }

    return [];
  }

  downloadCSV = (allDrives) => {
    csvConverter(allDrives, 'Saved Drives');
  };

  moveToHome = () => {
    const { history } = this.props;
    history.push('/');
  }

  moveToEdit = (driveId) => {
    const { history } = this.props;
    history.push(`/drive/edit/${driveId}`);
  }

  searchDrives = (drives) => {
    const { searchText } = this.state;
    this.setState(() => ({
      isLoading: true,
    }));
    const result = drives.filter((drive) => {  // eslint-disable-line
      if (includes(drive.companyName.toLowerCase(), searchText.toLowerCase())) {
        return drive;
      }
    });
    if (result.length > 0) {
      this.setState(() => ({
        filteredData: result,
        isLoading: false,
      }));
    } else {
      this.setState(() => ({
        emptySearchOpen: true,
        searchText: '',
        isLoading: false,
        filteredData: [],
      }));
    }
  }

  resetSearch = () => {
    this.setState(() => ({
      searchText: '',
      filteredData: [],
    }));
  }

  moveToTop = () => {
    document.getElementById('headerDiv').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
  }


  render() {
    const { isLoading, drives, searchText, filteredData, candidates, emptySearchOpen } = this.state;
    const { history } = this.props;
    const allDrives = this.getDrivesArray(drives, candidates);
    return (
      <div id="headerDiv">
        {isLoading ? (
          <ContentContainer>
            <LoaderWrapper>
              <CircularProgress />
            </LoaderWrapper>
          </ContentContainer>
        ) : (
          <ContentWrapper>
            <FloatingButtonContianer>
              <FloatingActionButton mini><ArrowUpIcon onTouchTap={this.moveToTop} /></FloatingActionButton>
            </FloatingButtonContianer>
            <DataWrapper>
              <CardHeader
                title={`Drives: ${filteredData.length === 0 ? allDrives.length : filteredData.length}`}
                style={{ paddingLeft: 0, marginTop: '8px' }}
                textStyle={{ paddingRight: 0 }}
              />
              <SearchWrpper>
                <TextField
                  hintText="Search by Name"
                  value={searchText}
                  style={{ marginLeft: 16 }}
                  onChange={(_, value) => {
                    this.setState(() => ({
                      searchText: value,
                    }));
                  }}
                />
                {searchText !== '' ? (
                  <IconButton style={{ marginLeft: '-42px' }}>
                    <ClearIcon color={theme.primary1Color} onTouchTap={this.resetSearch} />
                  </IconButton>
                  ) : null}
                <IconButton>
                  <SearchIcon
                    style={{ height: 48, width: 30 }}
                    color={theme.primary1Color}
                    onTouchTap={() => {
                      this.searchDrives(allDrives);
                    }}
                  />
                </IconButton>
              </SearchWrpper>

              <ButtonWrapper>
                <RaisedButton
                  primary
                  label="Download CSV"
                  onTouchTap={() => {
                    this.downloadCSV(allDrives);
                  }}
                />
              </ButtonWrapper>

            </DataWrapper>
            {filteredData.length === 0 ? (
              <ContentContainer>
                {allDrives.map(drive => (
                  <DriveCard key={drive.id} history={history} {...drive} />
                  ))}
              </ContentContainer>
              ) : (
                <ContentContainer>
                  {filteredData.map(data => (
                    <DriveCard key={data.id} history={history} {...data} />
                    ))}
                </ContentContainer>
                )}
          </ContentWrapper>
          )}
        <Snackbar
          bodyStyle={{ backgroundColor: theme.primary1Color }}
          open={emptySearchOpen}
          message="No Result found"
          autoHideDuration={5000}
          onRequestClose={() => {
            this.setState(() => ({
              emptySearchOpen: false,
            }));
          }}
        />
      </div>
    );
  }
}

SavedDrives.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};


export default SavedDrives;



// WEBPACK FOOTER //
// ./src/views/SavedDrives/SavedDrives.js